import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { userMachineCatalogueActions } from "../../constants/actionTypes";
import {
  labViewError,
  labViewSuccess,
  setCatalogLabsListData,
  setCatalogLabsListError,
  createVmError,
  createVmSuccess,
  resetQuotaValueSuccess,
  resetQuotaValueError,
  successCloudCatalogList,
  errorCloudCatalogList,
  successCloudLabExtension,
  errorCloudLabExtension,
  successCreateCloudLab,
  errorCreateCloudLab,
  successCloudLabList,
  errorCloudLabList,
  successCreateCloudLabFeedback,
  errorCreateCloudLabFeedback,
  successUpdateCloudLabFeedback,
  errorUpdateCloudLabFeedback,
  setBaseTemplateList,
  setLoadingBaseTemplates,
  updateBaseTemplateSuccessAction,
  updateBaseTemplateLoadingAction,
  updateBaseTemplateErrorAction,
  setExtensionAndBasePackLoadingAction,
  setExtensionAndBasePackAction,
  applyLabExtensionLoading,
  applyLabExtensionSuccess,
  applyLabExtensionError,
  successExportSkuTenantCatalog,
  errorExportSkuTenantCatalog,
  successCloudCatalog,
  errorCloudCatalog,
  applyCloudLabExtensionLoading,
  applyCloudLabExtensionError,
  applyCloudLabExtensionSuccess,
} from "../actions/userMachineCatalog";
import {
  fetchCatalogLabsList,
  labViewApi,
  createVmApi,
  resetQuotaValue,
  fetchCloudCatalogList,
  retrieveCloudLabExtension,
  createCloudLabApi,
  fetchCloudLabList,
  createCloudLabFeedbackApi,
  updateCloudLabFeedbackApi,
  createVmAdminApi,
  listBaseTemplatesRequest,
  updateBaseTemplateRequest,
  listExtensionAndBasePackRequest,
  applyLabExtensionRequest,
  exportTenantCatalogApi,
  retrieveCloudCatalog,
  applyCloudLabExtensionApi,
} from "../api/userMachineCatalog";
import { statusCode } from "../../constants/apis/apiStatus";
import { toastNotification } from "../../utils/toast";
import { toasterFlags } from "../../constants/componentConstants";

export function* fetchCatalogLabsListFunction({ payload }) {
  try {
    const data = yield call(fetchCatalogLabsList, payload);
    if (data.status === statusCode.Ok200) {
      yield put(setCatalogLabsListData(data));
    } else {
      yield put(setCatalogLabsListError(data));
    }
  } catch (err) {
    console.log(err);
    yield put(setCatalogLabsListError(err));
  }
}

export function* labViewFunction({ payload }) {
  try {
    const data = yield call(
      labViewApi,
      payload?.data,
      payload?.isManageVm,
      payload?.tenantId
    );
    if (data.status === statusCode.Ok200) {
      yield put(labViewSuccess(data));
    } else {
      yield put(labViewSuccess(data));
      toastNotification(
        toasterFlags.WARN,
        data?.data?.error && data?.data?.message
      );
    }
  } catch (err) {
    yield put(labViewError(err));
  }
}

export function* createVmFunction({ payload }) {
  try {
    const response = yield call(createVmApi, payload);
    if (response?.status === statusCode.Created201) {
      yield put(createVmSuccess(response));
    } else {
      yield put(createVmError(response));
      toastNotification(
        toasterFlags.ERROR,
        response?.data?.message || response?.data?.Failure || response?.error
      );
    }
  } catch (err) {
    yield put(createVmError(err));
  }
}

export function* createVmFunctionAdmin({ payload }) {
  try {
    const response = yield call(createVmAdminApi, payload);
    if (response?.status === statusCode.Ok200) {
      yield put(createVmSuccess(response));
      toastNotification(
        toasterFlags.SUCCESS,
        response?.data?.Success || response?.Success
      );
    } else {
      yield put(createVmError(response?.data?.message));
      toastNotification(
        toasterFlags.ERROR,
        response?.data?.message || response?.data?.Failure || response?.error
      );
    }
  } catch (err) {
    yield put(createVmError(err));
  }
}

export function* listBaseTemplateSaga({ payload }) {
  try {
    yield put(setLoadingBaseTemplates(true));
    const response = yield call(listBaseTemplatesRequest, payload);
    if (response?.status === statusCode.Ok200) {
      yield put(setBaseTemplateList(response));
      toastNotification(
        toasterFlags.SUCCESS,
        response?.data?.Success || response?.Success
      );
    } else {
      yield put(setBaseTemplateList({}));
      toastNotification(
        toasterFlags.ERROR,
        response?.data?.message || response?.error
      );
    }
    yield put(setLoadingBaseTemplates(false));
  } catch (err) {
    yield put(setLoadingBaseTemplates(false));
    yield put(setBaseTemplateList({}));
  }
}

export function* resetQuotaValuFunction({ payload }) {
  try {
    const data = yield call(resetQuotaValue, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(resetQuotaValueSuccess(data));
    } else {
      yield put(resetQuotaValueError(data));
      // toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
    }
  } catch (err) {
    // yield put(playPauseTenantError(err));
    yield put(resetQuotaValueError(err));
  }
}

export function* fetchCloudCatalogListSaga({ payload }) {
  try {
    const data = yield call(fetchCloudCatalogList, payload);
    if (data.status === statusCode.Ok200) {
      yield put(successCloudCatalogList(data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(errorCloudCatalogList(data));
    }
  } catch (err) {
    yield put(errorCloudCatalogList(err));
  }
}

export function* fetchCloudCatalogSaga({ payload }) {
  try {
    const data = yield call(
      retrieveCloudCatalog,
      payload?.id,
      payload?.urlParams
    );
    if (data.status === statusCode.Ok200) {
      yield put(successCloudCatalog(data));
    } else {
      yield put(errorCloudCatalog(data));
      toastNotification(
        toasterFlags.WARN,
        data?.data?.error && data?.data?.message
      );
    }
  } catch (err) {
    yield put(errorCloudCatalog(err));
  }
}

export function* fetchCloudLabExtensionSaga({ payload }) {
  try {
    const data = yield call(retrieveCloudLabExtension, payload);
    if (data.status === statusCode.Ok200) {
      yield put(successCloudLabExtension(data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(errorCloudLabExtension(data));
    }
  } catch (err) {
    yield put(errorCloudLabExtension(err));
  }
}

export function* applyCloudLabExtensionSaga({ payload }) {
  try {
    const data = yield call(applyCloudLabExtensionApi, payload);
    if (data.status === statusCode.Ok200) {
      yield put(applyCloudLabExtensionSuccess(data));
      toastNotification(toasterFlags?.SUCCESS, data?.data?.message);
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(applyCloudLabExtensionError(data));
    }
  } catch (err) {
    yield put(applyCloudLabExtensionError(err));
  } finally {
    yield put(applyCloudLabExtensionLoading(false));
  }
}

export function* fetchCloudLabListSaga({ payload }) {
  try {
    yield put(setLoadingBaseTemplates(true));
    const data = yield call(fetchCloudLabList, payload);
    if (data.status === statusCode.Ok200) {
      yield put(successCloudLabList(data));
      yield put(setLoadingBaseTemplates(false));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(errorCloudLabList(data));
    }
  } catch (err) {
    yield put(errorCloudLabList(err));
  }
}

export function* createCloudLabSaga({ payload }) {
  try {
    const data = yield call(createCloudLabApi, payload);
    if (data.status === statusCode.Created201) {
      toastNotification(toasterFlags?.SUCCESS, data?.data?.message || "");
      yield put(successCreateCloudLab(data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(errorCreateCloudLab(data));
    }
  } catch (err) {
    yield put(errorCreateCloudLab(err));
  }
}

export function* createCloudLabFeedbackSaga({ payload }) {
  try {
    const data = yield call(createCloudLabFeedbackApi, payload);
    if (data.status === statusCode.Created201) {
      yield put(successCreateCloudLabFeedback(data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(errorCreateCloudLabFeedback(data));
    }
  } catch (err) {
    yield put(errorCreateCloudLabFeedback(err));
  }
}

export function* updateCloudLabFeedbackSaga({ payload, id }) {
  try {
    const data = yield call(updateCloudLabFeedbackApi, payload, id);
    if (data.status === statusCode.Ok200) {
      yield put(successUpdateCloudLabFeedback(data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(errorUpdateCloudLabFeedback(data));
    }
  } catch (err) {
    yield put(errorUpdateCloudLabFeedback(err));
  }
}

export function* exportTenantCatalogSaga({ payload }) {
  try {
    const data = yield call(exportTenantCatalogApi, payload);
    if (data.status === statusCode.Ok200) {
      yield put(successExportSkuTenantCatalog(data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(errorExportSkuTenantCatalog(data));
    }
  } catch (err) {
    yield put(errorExportSkuTenantCatalog(err));
  }
}

export function* updateBaseTemplateSaga({ payload }) {
  try {
    yield put(updateBaseTemplateLoadingAction(true));
    const data = yield call(updateBaseTemplateRequest, payload);
    yield put(updateBaseTemplateLoadingAction(false));
    if (data.status === statusCode.Ok200) {
      yield put(updateBaseTemplateSuccessAction(data?.data?.success));
      toastNotification(toasterFlags?.Success, data?.data?.success);
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.error);
      yield put(updateBaseTemplateErrorAction(data?.data?.error));
    }
  } catch (err) {
    yield put(updateBaseTemplateErrorAction(err));
    yield put(updateBaseTemplateLoadingAction(false));
  }
}

export function* applyLabExtensionSaga({ payload }) {
  try {
    yield put(applyLabExtensionLoading(true));
    const data = yield call(applyLabExtensionRequest, payload);
    yield put(applyLabExtensionLoading(false));
    if (data.status === statusCode.Ok200) {
      yield put(applyLabExtensionSuccess(data?.data?.success));
      toastNotification(toasterFlags?.Success, data?.data?.success);
    } else {
      toastNotification(
        toasterFlags?.WARN,
        data?.data?.error && "Something went wrong"
      );
      yield put(applyLabExtensionError(data?.data?.message));
    }
  } catch (err) {
    yield put(applyLabExtensionError(err));
    yield put(applyLabExtensionLoading(false));
  }
}

export function* getExtensionAndBasePackSaga({ payload }) {
  try {
    yield put(setExtensionAndBasePackLoadingAction(true));
    const data = yield call(listExtensionAndBasePackRequest, payload);
    yield put(setExtensionAndBasePackLoadingAction(false));
    if (data.status === statusCode.Ok200) {
      yield put(setExtensionAndBasePackAction(data?.data));
      toastNotification(toasterFlags?.Success, data?.data?.Success);
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(setExtensionAndBasePackAction({}));
    }
  } catch (err) {
    yield put(setExtensionAndBasePackAction({}));
    yield put(setExtensionAndBasePackLoadingAction(false));
  }
}

export function* userMachineCatalogRootSaga() {
  yield takeLatest(
    userMachineCatalogueActions.FETCH_CATALOG_LABS_LIST_DATA,
    fetchCatalogLabsListFunction
  );
  yield takeLatest(
    userMachineCatalogueActions.LAB_VIEW_REQUEST,
    labViewFunction
  );
  yield takeLatest(
    userMachineCatalogueActions.CREATE_VM_REQUEST,
    createVmFunction
  );
  yield takeLatest(
    userMachineCatalogueActions.CREATE_VM_REQUEST_ADMIN,
    createVmFunctionAdmin
  );
  yield takeLatest(
    userMachineCatalogueActions.GET_BASE_TEMPLATES_LIST,
    listBaseTemplateSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.UPDATE_BASE_TEMPLATE,
    updateBaseTemplateSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.GET_EXTENSION_AND_BASE_PACKS_ACTION,
    getExtensionAndBasePackSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.APPLY_LAB_EXTENSION,
    applyLabExtensionSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.QUOTA_RESET_VALUE_REQUEST,
    resetQuotaValuFunction
  );
  yield takeLatest(
    userMachineCatalogueActions.REQUEST_CLOUD_CATALOG_LIST,
    fetchCloudCatalogListSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.REQUEST_CLOUD_CATALOG,
    fetchCloudCatalogSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.REQUEST_CLOUD_LAB_EXTENSION,
    fetchCloudLabExtensionSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.APPLY_CLOUD_LAB_EXTENSION_ACTION,
    applyCloudLabExtensionSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.REQUEST_CREATE_CLOUD_LAB,
    createCloudLabSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.REQUEST_CLOUD_LAB_LIST,
    fetchCloudLabListSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.REQUEST_CREATE_CLOUD_LAB_FEEDBACK,
    createCloudLabFeedbackSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.REQUEST_UPDATE_CLOUD_LAB_FEEDBACK,
    updateCloudLabFeedbackSaga
  );
  yield takeLatest(
    userMachineCatalogueActions.EXPORT_SKU_TENANT_CATALOG,
    exportTenantCatalogSaga
  );
}

export default function* rootSaga() {
  yield all([fork(userMachineCatalogRootSaga)]);
}
